// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicyModalBody_container__9izc+","consentSection":"PrivacyPolicyModalBody_consentSection__-79nq"};